namespace $.$$ {

	export class $shm_hitalama_version_label extends $.$shm_hitalama_version_label {

		title() {
			if( this.outdated() ) return `v${ this.version() } (${ this.date() }) · доступна новая версия v${ this.available_version() } — обновите страницу`
			return `v${ this.version() } (${ this.date() })`
		}

		outdated() {
			const available = this.available_version()
			return Boolean( available && available !== '-' && available !== this.version() )
		}

	}

}
